import { render, staticRenderFns } from "./MensajeVeridas.vue?vue&type=template&id=25ba4620&scoped=true"
import script from "./MensajeVeridas.vue?vue&type=script&lang=js"
export * from "./MensajeVeridas.vue?vue&type=script&lang=js"
import style0 from "./MensajeVeridas.vue?vue&type=style&index=0&id=25ba4620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba4620",
  null
  
)

export default component.exports